import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Swal from 'sweetalert2'
import Select2 from 'v-select2-component';
import VueHtmlToPaper from 'vue-html-to-paper';
import './assets/app.css';

Vue.component('Select2', Select2);
// CommonJS
window.Swal=Swal;
Vue.config.productionTip = false
const options = {
  name: '_blank',
  specs: ['fullscreen=yes','titlebar=yes', 'scrollbars=yes'],
  styles: [/* optional external stylesheets */
    'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
  ]
};
new Vue({
  router,
  options,
  VueHtmlToPaper,
  vuetify,
  render: h => h(App)
}).$mount('#app')
